import { CellClassRules, ValueFormatterParams } from 'ag-grid-enterprise'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'

const lastRowRules = {
  ['font-medium']: (params) => {
    return params.data?.index === 'gry'
  },
} satisfies CellClassRules

const customFormatter = (params: ValueFormatterParams) => {
  if (['Return %', 'GRY to Maturity (Av. %)'].includes(params.data?.index)) {
    return numberFormatter({
      suffix: '%',
      transformer: (val) => val * 100,
    })(params)
  }
  return numberFormatter()(params)
}

export const colDefs = createColDefs([
  {
    field: 'index',
    headerName: 'Immediate Spot Moves',
    cellClassRules: lastRowRules,
  },
  {
    field: '-0.2',
    headerName: '-20%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '-0.15',
    headerName: '-15%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '-0.1',
    headerName: '-10%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '-0.05',
    headerName: '-5%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '0.0',
    headerName: '0%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '0.05',
    headerName: '5%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '0.1',
    headerName: '10%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '0.15',
    headerName: '15%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
  {
    field: '0.2',
    headerName: '20%',
    cellClassRules: lastRowRules,
    valueFormatter: customFormatter,
  },
])
